import { withInstall } from '@zoryn/utils'
import Autocomplete from './src/autocomplete.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZAutocomplete: SFCWithInstall<typeof Autocomplete> =
  withInstall(Autocomplete)

export default ZAutocomplete

export * from './src/autocomplete'
